import { Alert } from "flowbite-react";
import React from "react";
import { useAlert } from "app/context/useAlert";

export default function ContextAlert() {
const {alert, close} = useAlert()

  return (
    <>
    {alert.show &&
      <Alert color={alert.type} onDismiss={close}>
      <span className="">
        {alert.title}
      </span>
    </Alert>
}
    </>
  );
}